import React, { FC } from 'react'

const CitoraLogo: FC = () => (
  <svg width="119" height="40" viewBox="0 0 119 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M67.093 15.5833V25.8169H68.6506V17.1412C68.6506 16.7282 68.4865 16.3321 68.1944 16.04C67.9023 15.7478 67.5062 15.5836 67.093 15.5833Z"
      fill="white"
    />
    <path d="M58.5061 14.1587H56.9484V25.8168H58.5061V14.1587Z" fill="white" />
    <path
      d="M46.7 15.4662C47.4615 15.4601 48.21 15.6626 48.8645 16.0517C49.4976 16.4205 50.0108 16.9642 50.3424 17.6173L50.425 17.7824L51.7051 17.0251L51.6244 16.8792C51.1529 16.0122 50.4489 15.2939 49.5915 14.8048C48.7161 14.2881 47.7166 14.0193 46.7 14.0273C44.9897 14.0273 43.554 14.6109 42.4324 15.7638C41.3108 16.9166 40.7461 18.3421 40.7461 20.0075C40.7461 21.673 41.3136 23.0994 42.4324 24.2503C43.5511 25.4013 44.9897 25.9868 46.7 25.9868C47.7165 25.9947 48.7161 25.7259 49.5915 25.2093C50.4521 24.7176 51.1569 23.9938 51.6254 23.1205L51.7041 22.9727L50.4241 22.2374L50.3424 22.3996C50.0108 23.0528 49.4976 23.5964 48.8645 23.9652C48.21 24.3543 47.4615 24.5568 46.7 24.5508C45.3796 24.5508 44.2877 24.1102 43.4532 23.2405C42.6187 22.3708 42.1942 21.2813 42.1942 20.0075C42.1942 18.7337 42.6177 17.6452 43.4532 16.7736C44.2887 15.902 45.3796 15.4662 46.7 15.4662Z"
      fill="white"
    />
    <path
      d="M113.655 14.4448C113.6 14.3193 113.51 14.2124 113.396 14.1367C113.283 14.0598 113.149 14.0193 113.012 14.0206C112.877 14.0225 112.745 14.0642 112.633 14.1406C112.521 14.2173 112.433 14.3245 112.379 14.4496L107.467 25.7478H109.18L109.224 25.6413C110.487 22.6127 111.763 19.5439 113.017 16.5135L116.913 25.6432L116.957 25.7478H118.671L113.655 14.4448Z"
      fill="white"
    />
    <path d="M72.0865 14.179H63.6368V15.5833H72.0865V14.179Z" fill="white" />
    <path
      d="M82.1573 13.987C80.4748 13.987 79.0324 14.5754 77.8705 15.7369C76.7085 16.8984 76.117 18.3114 76.117 19.9663C76.1049 20.756 76.2541 21.5399 76.5556 22.2699C76.8572 22.9999 77.3046 23.6608 77.8705 24.212C79.0363 25.3638 80.4767 25.9465 82.1573 25.9465C83.8378 25.9465 85.2783 25.3638 86.4441 24.212C87.0097 23.6606 87.4569 22.9997 87.7583 22.2697C88.0596 21.5397 88.2088 20.7559 88.1966 19.9663C88.1966 18.3114 87.6061 16.8888 86.4441 15.7427C85.2821 14.5965 83.8378 13.987 82.1573 13.987ZM86.7187 19.9663C86.7292 20.5653 86.6186 21.1603 86.3933 21.7156C86.168 22.2708 85.8329 22.7748 85.4079 23.1973C84.5388 24.0689 83.4451 24.5105 82.1592 24.5105C80.8734 24.5105 79.7805 24.0689 78.9105 23.1983C78.4849 22.7758 78.1491 22.2718 77.9232 21.7164C77.6973 21.161 77.5859 20.5657 77.5958 19.9663C77.5958 18.7049 78.0366 17.6231 78.9076 16.7515C79.7786 15.8799 80.8695 15.423 82.1554 15.423C83.4412 15.423 84.534 15.8694 85.4041 16.7515C86.2741 17.6337 86.7187 18.7049 86.7187 19.9663Z"
      fill="white"
    />
    <path
      d="M101.398 19.8635C101.879 19.2535 102.138 18.4978 102.132 17.721C102.138 17.2546 102.047 16.792 101.865 16.3625C101.683 15.9329 101.415 15.5457 101.075 15.2252C100.749 14.8882 100.356 14.6217 99.9227 14.4419C99.489 14.2621 99.0231 14.1729 98.5537 14.1799H93.8482V25.7545H95.328V21.2621H98.2329L100.891 25.7545H102.591L99.7713 21.0442C100.418 20.8196 100.984 20.4088 101.398 19.8635ZM100.651 17.721C100.655 18.0018 100.603 18.2806 100.498 18.5408C100.392 18.801 100.235 19.0373 100.036 19.2358C99.8463 19.4368 99.6163 19.5959 99.3612 19.703C99.106 19.8101 98.8313 19.8629 98.5546 19.8578H95.3242V15.5833H98.5546C98.8313 15.5782 99.106 15.6309 99.3612 15.738C99.6163 15.8451 99.8463 16.0043 100.036 16.2053C100.237 16.4027 100.395 16.6389 100.501 16.8996C100.606 17.1603 100.657 17.4398 100.651 17.721Z"
      fill="white"
    />
    <mask
      id="mask0_2075_5280"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="35"
      height="40"
      style={{ maskType: 'alpha' }}
    >
      <path
        d="M34.6667 10.0161L19.925 18.5131C18.4962 19.3364 18.4971 20.6827 19.925 21.506L34.6667 29.9964V28.604L27.9786 24.7484C23.4578 22.1422 23.4578 17.8779 27.9786 15.2726L34.6667 11.418V10.0161Z"
        fill="black"
      />
      <path
        d="M17.3276 0L16.11 0.698572V8.41453C16.11 13.6298 12.414 15.7611 7.89607 13.1491L1.22335 9.2935L0 9.99879L14.7474 18.5054C16.1743 19.3297 17.3401 18.6561 17.3401 17.0085L17.3276 0Z"
        fill="black"
      />
      <path
        d="M17.3276 40L16.11 39.3014V31.5855C16.11 26.3702 12.414 24.2389 7.89607 26.8509L1.22335 30.7084L0 30.0031L14.7474 21.4936C16.1743 20.6693 17.3401 21.3429 17.3401 22.9905L17.3276 40Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_2075_5280)">
      <path
        d="M17.3263 39.9964L16.1088 39.2978V31.5819C16.1088 26.3666 12.4128 24.2353 7.89485 26.8473L1.22213 30.7048L-0.0012207 29.9995L14.7462 21.49C16.1731 20.6657 17.3388 21.3393 17.3388 22.9869L17.3263 39.9964Z"
        fill="url(#paint0_linear_2075_5280)"
      />
      <path
        d="M34.6684 10.0156L19.9267 18.5127C18.4979 19.336 18.4989 20.6823 19.9267 21.5056L34.6684 29.9959V28.6036L27.9803 24.748C23.4595 22.1418 23.4595 17.8774 27.9803 15.2722L34.6684 11.4176V10.0156Z"
        fill="url(#paint1_linear_2075_5280)"
      />
      <path
        d="M17.3263 0L16.1088 0.698572V8.41453C16.1088 13.6298 12.4128 15.761 7.89485 13.1491L1.22213 9.2935L-0.0012207 9.99879L14.7462 18.5054C16.1731 19.3297 17.3388 18.6561 17.3388 17.0085L17.3263 0Z"
        fill="url(#paint2_linear_2075_5280)"
      />
      <ellipse
        cx="14.5934"
        cy="14.5833"
        rx="14.5934"
        ry="14.5833"
        transform="matrix(-1 0 0 1 31.9375 5.41667)"
        fill="url(#paint3_radial_2075_5280)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2075_5280"
        x1="13.8267"
        y1="26.211"
        x2="8.67391"
        y2="34.3627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2075_5280"
        x1="24.7257"
        y1="20.0058"
        x2="34.6683"
        y2="20.0058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2075_5280"
        x1="14.091"
        y1="13.5587"
        x2="9.05974"
        y2="4.96233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_2075_5280"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.5934 14.5833) rotate(90) scale(14.5833 14.5934)"
      >
        <stop offset="0.652816" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)

export default CitoraLogo
